// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1F2LkI4MXGRkKCnWd-djw9"};